
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Guide pour créer une page Facebook pour son entreprise",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Créez une page Facebook professionnelle efficace grâce au guide pas à pas d’ALEO et boostez la visibilité de votre entreprise dès aujourd’hui.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Guide pour créer une page Facebook pour son entreprise",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Créez une page Facebook professionnelle efficace grâce au guide pas à pas d’ALEO et boostez la visibilité de votre entreprise dès aujourd’hui.",
        },
      ],
    };
  },
};
